export type ImageDimensions = Readonly<{ width: number; height: number }>;

export const imageDimensions: Record<string, ImageDimensions> = {
  "best-2026-02-01": { width: 1012, height: 1800 },
  "best-2026-02-02": { width: 1800, height: 1350 },
  "best-2026-02-03": { width: 1800, height: 1350 },
  "best-2026-02-04": { width: 1800, height: 1350 },
  "best-2026-02-05": { width: 1800, height: 1350 },
  "best-2026-02-06": { width: 1350, height: 1800 },
  "best-2026-02-07": { width: 1800, height: 1350 },
  "best-2026-02-08": { width: 1350, height: 1800 },
  "best-2026-02-09": { width: 1350, height: 1800 },
  "best-2026-02-10": { width: 1350, height: 1800 },
  "best-2026-02-11": { width: 1350, height: 1800 },
  "best-2026-02-12": { width: 1350, height: 1800 },
  "best-2026-02-13": { width: 1350, height: 1800 },
  "best-2026-02-14": { width: 1350, height: 1800 },
  "best-2026-02-15": { width: 1595, height: 1800 },
  "best-2026-02-16": { width: 1536, height: 2048 },
  "best-2026-02-17": { width: 1350, height: 1800 },
  "best-2026-02-18": { width: 1350, height: 1800 },
  "best-2026-02-19": { width: 1350, height: 1800 },
  "best-2026-02-20": { width: 1350, height: 1800 },
  "best-2026-02-21": { width: 1350, height: 1800 },
  "best-2026-02-22": { width: 1013, height: 1800 },
  "best-2026-02-23": { width: 1350, height: 1800 },
  "best-2026-02-24": { width: 1350, height: 1800 },
  "best-2026-02-25": { width: 1013, height: 1800 },
  "best-2026-04-01": { width: 1350, height: 1800 },
  "best-2026-04-02": { width: 1013, height: 1800 },
  "best-2026-04-03": { width: 1350, height: 1800 },
  "best-2026-04-04": { width: 1536, height: 2048 },
  "best-2026-04-05": { width: 1350, height: 1800 },
  "best-2026-04-06": { width: 1350, height: 1800 },
  "best-2026-04-07": { width: 1350, height: 1800 },
  "best-2026-04-08": { width: 1013, height: 1800 },
  "best-2026-04-09": { width: 1013, height: 1800 },
  "best-2026-04-10": { width: 1800, height: 1013 },
  "best-2026-04-11": { width: 1350, height: 1800 },
  "best-2026-04-12": { width: 1800, height: 1013 },
  "best-2026-04-13": { width: 1013, height: 1800 },
  "best-2026-04-14": { width: 1013, height: 1800 },
  "best-2026-04-15": { width: 1013, height: 1800 },
  "best-2026-04-16": { width: 1013, height: 1800 },
  "best-2026-04-17": { width: 1013, height: 1800 },
  "best-2026-04-18": { width: 1013, height: 1800 },
  "best-2026-04-19": { width: 1013, height: 1800 },
  "best-2026-04-20": { width: 1013, height: 1800 },
  "best-2026-04-21": { width: 1536, height: 2048 },
  "best-2026-04-22": { width: 1013, height: 1800 },
  "best-2026-04-23": { width: 1350, height: 1800 },
  "best-2026-04-24": { width: 1013, height: 1800 },
  "best-2026-04-25": { width: 1350, height: 1800 },
  "best-2026-05-01": { width: 1800, height: 1013 },
  "best-2026-05-02": { width: 1350, height: 1800 },
  "best-2026-05-03": { width: 1012, height: 1800 },
  "best-2026-05-04": { width: 1350, height: 1800 },
  "best-2026-05-05": { width: 1012, height: 1800 },
  "best-2026-05-06": { width: 1330, height: 2364 },
  "best-2026-05-07": { width: 1012, height: 1800 },
  "best-2026-05-08": { width: 2048, height: 1536 },
  "best-2026-05-09": { width: 1350, height: 1800 },
  "best-2026-05-10": { width: 1013, height: 1800 },
  "best-2026-05-11": { width: 1800, height: 1013 },
  "best-2026-05-12": { width: 2048, height: 1536 },
  "best-2026-05-13": { width: 1350, height: 1800 },
  "best-2026-05-14": { width: 1800, height: 1013 },
  "best-2026-05-15": { width: 1350, height: 1800 },
  "best-2026-05-16": { width: 1012, height: 1800 },
  "best-2026-05-17": { width: 1013, height: 1800 },
  "best-2026-05-18": { width: 1012, height: 1800 },
  "best-2026-05-19": { width: 1012, height: 1800 },
  "best-2026-05-20": { width: 1013, height: 1800 },
  "best-2026-05-21": { width: 1012, height: 1800 },
  "best-2026-05-22": { width: 1800, height: 1013 },
  "best-2026-05-23": { width: 1800, height: 1350 },
  "best-2026-05-24": { width: 1800, height: 1013 },
  "best-2026-05-25": { width: 1012, height: 1800 },
  "best-2026-07-01": { width: 726, height: 1800 },
  "best-2026-07-02": { width: 1080, height: 1080 },
  "best-2026-07-03": { width: 1080, height: 1080 },
  "best-2026-07-04": { width: 1350, height: 1800 },
  "best-2026-07-05": { width: 1350, height: 1800 },
  "best-2026-07-06": { width: 1080, height: 1080 },
  "best-2026-07-07": { width: 1013, height: 1800 },
  "best-2026-07-08": { width: 1013, height: 1800 },
  "best-2026-07-09": { width: 1013, height: 1800 },
  "best-2026-07-10": { width: 1800, height: 1800 },
  "best-2026-07-11": { width: 1013, height: 1800 },
  "best-2026-07-12": { width: 1080, height: 1080 },
  "best-2026-07-13": { width: 1800, height: 1800 },
  "best-2026-07-14": { width: 941, height: 1672 },
  "best-2026-07-15": { width: 1080, height: 1080 },
  "best-2026-07-16": { width: 1080, height: 1790 },
  "best-2026-07-17": { width: 1800, height: 1350 },
  "best-2026-07-18": { width: 1080, height: 1350 },
  "best-2026-07-19": { width: 1800, height: 942 },
  "best-2026-07-20": { width: 1800, height: 1800 },
  "best-2026-07-21": { width: 1800, height: 1350 },
  "best-2026-07-22": { width: 1252, height: 656 },
  "best-2026-07-23": { width: 1350, height: 1800 },
  "best-2026-07-24": { width: 1012, height: 1800 },
  "best-2026-07-25": { width: 1800, height: 1350 },
  "concert-babymetal-arena-lasers": { width: 2048, height: 1536 },
  "concert-babymetal-dark-red": { width: 2048, height: 1536 },
  "concert-babymetal-light-beam": { width: 2048, height: 1536 },
  "concert-babymetal-red-arena": { width: 2048, height: 1536 },
  "concert-epica-blue-arena": { width: 2400, height: 1350 },
  "concert-epica-purple-stage": { width: 2400, height: 1350 },
  "concert-epica-red-smoke": { width: 2400, height: 1350 },
  "concert-epica-red-wide": { width: 2400, height: 1350 },
  "concert-epica-symphonic-wide": { width: 2400, height: 1350 },
  "concert-megadeth-lights-wide": { width: 2400, height: 1350 },
  "concert-megadeth-red-wide": { width: 2400, height: 1350 },
  "concert-metallica-crowd-rig": { width: 2400, height: 1800 },
  "concert-metallica-poster": { width: 1920, height: 1920 },
  "concert-metallica-red-stage": { width: 1800, height: 2400 },
  "concert-metallica-stadium-open": { width: 2400, height: 1800 },
  "concert-metallica-tower": { width: 1800, height: 2400 },
  "concert-slipknot-blue-mask": { width: 2400, height: 1800 },
  "concert-slipknot-blue-wide": { width: 2400, height: 1800 },
  "concert-slipknot-red-stage": { width: 2400, height: 1800 },
  "concert-slipknot-red-wall": { width: 2400, height: 1800 },
  "ibiza-bebe-hidden-road": { width: 2400, height: 1350 },
  "ibiza-maniaca-low-angle": { width: 1350, height: 2400 },
  "nature-aloe": { width: 1800, height: 2400 },
  "nature-red-flower": { width: 1800, height: 2400 },
  "nature-red-tree": { width: 2400, height: 1800 },
  "personal-red-car": { width: 2400, height: 1350 },
  "places-agave": { width: 2400, height: 1800 },
  "places-cathedral": { width: 1800, height: 2400 },
  "places-forest": { width: 1330, height: 2364 },
  "places-reflection-pond": { width: 2400, height: 1800 },
  "places-tequila": { width: 2400, height: 1800 },
  "places-tequila-sign": { width: 2400, height: 1800 },
  "places-torii": { width: 1800, height: 2400 },
  "sunset-cloud-ribbon": { width: 2400, height: 1800 },
  "sunset-ember": { width: 2400, height: 1800 },
  "sunset-orange-window": { width: 1330, height: 2364 },
  "sunset-reforma": { width: 1350, height: 2400 },
  "sunset-rooftop": { width: 2400, height: 1350 },
  "sunset-storm-sun": { width: 2400, height: 1800 },
};
